export enum CreditorAccountSelector{
    UnitId = 0,
    NameId = 1,
    ExternalVoucherNo = 2
}